<template>
  <div class="base_detail_modal" >
     
    <Modal    
          v-model="detailModal"
          :title="`【${dataDetail['房屋地址']}】维修详情`" 
            :width="screenWidth*0.8"
          @on-cancel="cancel" @on-visible-change="handleVisibleChange">
          <div class="base-modal"> 
            <Tabs value="1" v-if="detailModal" :style="{'height':screenHeight*0.5+'px'}">
              <TabPane label="基础信息" name="1">
                <VuePerfectScrollbar style=" display: block;overflow:auto;" :style="{'height':screenHeight*0.5+'px'}"> 
                  
                  <div v-for="(key, index) in keyList" :key="key " >
                    <template  v-if=" index % 2 == 0 " >
                      <div class="base-modal-line" :style="index==0?'border-top:1px solid #c3c3c3':''"> 
                        <div   class="item_1" > 
                          <!-- :style="getMaxLineHeight(index)" -->
                          <div class="item_1-title" >{{ keyList[index] }}:</div>
                          <div class="item_1-value">{{ dataDetail[keyList[index]] }}</div>
                        </div>
                        <div   class="item_1"  > 
                          <!--  :style="getMaxLineHeight(index)" -->
                          <div class="item_1-title">{{ keyList[index+1] }}:</div>
                          <div class="item_1-value">{{ dataDetail[keyList[index+1]] }}</div>
                        </div>
                      </div>

                    </template>
                    
                  </div> 
                    
              </VuePerfectScrollbar>
                
              </TabPane>
         
              <TabPane label="损坏图片" name="2">
                <VuePerfectScrollbar style=" display: block;height:600px ;overflow:auto;">  
                    <template  > 
                      <Alert>租客上传材料</Alert>   
                      <div v-if="zkscImgList.length==0">暂无照片</div>
                      <div style="display: flex;gap:30px;" v-else>
                        <el-image
                          v-for="(item, index) in zkscImgList"
                          :key="item"
                          style="width: 300px; height: 300px"
                          :src="item.img"
                          :preview-src-list="zkscImgList.map(imgObj => imgObj.img)">
                        </el-image>
                      </div>  
                    </template>  
              </VuePerfectScrollbar>
                
              </TabPane>
              <TabPane label="维修图片" name="3">
                <VuePerfectScrollbar style=" display: block;height:600px ;overflow:auto;">  
                    <template  > 
                      <Alert>维修工上传材料</Alert>   
                      <div v-if="smwxImgList.length==0">暂无照片</div>
                      <div style="display: flex;gap:30px;" v-else>
                        <el-image
                          v-for="(item, index) in smwxImgList"
                          :key="item"
                          style="width: 300px; height: 300px"
                          :src="item.img"
                          :preview-src-list="smwxImgList.map(imgObj => imgObj.img)">
                        </el-image>
                      </div>  
                    </template>  
              </VuePerfectScrollbar>
                
              </TabPane>
          </Tabs>

          
          </div>
          <template #footer>
                <div></div>
                <Button type="primary" style="width:200px;z-index:999;" @click="detailModal=false">关闭</Button>
            </template>
    </Modal>

  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import RecursiveRenderer from './line/line.vue';

import {zfglMethod_2_001} from "@/api/2租房管理/2_001_cxfy.js"; 
import {utilTools} from "@/utils/js/utilTools.js"
import {fileMethod} from "@/api/files/fileMethod";
import { get } from 'lodash';
export default {
  name:"base_detail_modal",
  comments:{VuePerfectScrollbar,RecursiveRenderer},
  props:{
    dataDetail:{
      type:Object,
      default:{},
    },
    photoKeyList:{
      type:Array,
      default:[]
    },
    otherKeyList:{
      type:Array,
      default:[]
    },
    keyList:{
      type:Array,
      default:[]
    }
  },
    data() {
        return { 
          imgBaseUrl:"https://mp.xiaojiabiyu.net.cn/cms/v1/files/transform?uri=",
          detailModal:false,//控制弹窗开关 
          keyNotShow:["id","clsId","dataFieldMap","ciSource","tVersion","ciStatus","viewId","tenant"],
          dataDetailShow:{},
          fileList:[],
          czImgList:[],
          sfzImgList:[],
          fwtghtImgList:[],
          sqhtsImgList:[],

          ktImgList:[],
          cfImgList:[],
          wsImgList:[],
          wsjImgList:[],
          qtImgList:[],
          zkscImgList:[],
          smwxImgList:[],
          

        }
    },
    computed: {
      
        screenWidth() {
            return this.$screenWidth;
        },
        screenHeight() {
            return this.$screenHeight;
        },
    },
    mounted(){
      
    },
    created(){  
      // this.$nextTick(()=>{
      //   this.dataDetail = this.cleanData(this.dataDetail, this.keyNotShow);
      // }) 
    


    },
   
    watch:{},
    methods:{
      handleVisibleChange(visible){
        console.log("visible==",visible)
        if(visible){
          // this.cleanPhotoList("上门维修","文件") 
          this.cleanPhotoListV3("租客上传","1_上门维修",this.dataDetail.id,"租客上传",null,null)
          this.cleanPhotoListV3("上门维修","1_上门维修",this.dataDetail.id,"上门维修",null,null)
        }
       
      },
       // 新版清洗照片（新旧系统一起获取）（非房源版本）
       cleanPhotoListV3(key,father_table,father_id,type_1,type_2,old_data){
        let data= []
        //  新系统
        fileMethod.selectFiles({father_table:father_table,father_id:father_id,type_1:type_1,type_2:type_2}).then((res)=>{
          console.log(key,"--查询结果--",res)
         if(res.data.selectRes){
          res.data.selectRes.forEach((i)=>{
              let new_obj={
                    show_name:i.show_name,
                    type_2:i.type_2,
                    img: window.applicationConfig.fileBaseUrl + i.show_path,
                    suffix:i.suffix, 
                    source:"new_system",
                    id:i.id
                  }
                  data.push(new_obj);
            })
         } 
         console.log("查询后组装--",data)
         this.saveImage(key,data)
        })
      
      
         
      },
      cleanData(obj, properties) { 
        // console.log("obj===",obj)
        properties.forEach(property => {
          delete obj[property];
        }); 
        return obj;
      },
      // 判断是否为普通值（字符串、数字等）
      isPrimitive(key) { 
        let value = this.dataDetail[key]
          return typeof value === "string" || typeof value === "number" || typeof value === "boolean";
        },
        // 判断是否为数组
        isArray(key) {
          let value = this.dataDetail[key]
          return Array.isArray(value) && value.every((item) => typeof item !== "object");
        },
        // 判断是否为对象数组
        isArrayOfObjects(key) {
          let value = this.dataDetail[key] 
          return Array.isArray(value) && value.every((item) => typeof item === "object");
        },
        // 判断是否为对象
        isObject(key) {
          let value = this.dataDetail[key]
          return typeof value === "object" && !Array.isArray(value) && value !== null;
        },
        // 动态生成表格列
        getColumns(array) {
          if (!array.length) return [];
          return Object.keys(array[0]).map((key) => ({
            title: key,
            key: key,
          }));
        },
   
         cleanPhotoList(key,oldKey){ 
          if(this.dataDetail.source==="new_system"){
            let data = this.dataDetail[key];
           return   this.getPhotoList_newSystem(key,data)
          }else{
            let data = JSON.parse(this.dataDetail.data_field_map)['损坏情况附件']?JSON.parse(this.dataDetail.data_field_map)['损坏情况附件']:[]
            console.log("fj=data=",JSON.parse(this.dataDetail.data_field_map))
         
            if (data.length === 0) {
              this.saveImage(oldKey,[])
            }
            return  this.getPhotoList_oldSystem(oldKey,data)
          } 
         },
        //房屋照片特例
       async   cleanPhotoList_fw(key) {
          if (this.dataDetail.source === "new_system") {
            try {
              const res = await zfglMethod_2_001.getHousePhotosById({ id: this.dataDetail.id, type_1: "房屋原貌", type_2: key });
              console.log("图片详情res===", res.data.list);
              
              let imgList = [];
              if (res.data && res.data.list.length > 0) {
                res.data.list.forEach((i) => {
                  imgList.push("http://localhost:8080/xjby/view/" + i.show_path);
                });
              }
              console.log("imgList===", imgList);
              this.saveImage(key,imgList)
              
            } catch (error) {
              this.saveImage(key,imgList)
            }
          } else {
            if (!this.dataDetail['房屋原貌']) {
              this.saveImage(key,[])
            }

            let data = JSON.parse(this.dataDetail['房屋原貌']);
            console.log("fjdata==",data)
            if (data.length === 0) {
              this.saveImage(key,[])
            }
            return this.getPhotoList_oldSystem(key, data);
          }
        },

//旧系统获取图片
        getPhotoList_oldSystem(key,data){
          let imgList = [];
          
          for (const obj of data) {
            if (obj.bz === "new_system") {
              
              imgList.push("http://localhost:8080/xjby/view/"+obj.show_url);
            } else {
              imgList.push(this.imgBaseUrl + obj.fileAddress);
            }
          }
          console.log("imgList==",imgList) 
          this.saveImage(key,imgList)
        },
//新系统获取图片
        getPhotoList_newSystem(key,data){
          let imgList = [];
          zfglMethod_2_001.getHousePhotosById({id:this.dataDetail.id,type_1:key}).then((res)=>{
           if(res.data!=null&&res.data.list.length>0){
            res.data.list.forEach((i)=>{
              imgList.push("http://localhost:8080/xjby/view/"+i.show_path);
            })
           }
           this.saveImage(key,imgList)
          })
          
        },
        // 存放照片
        saveImage(key,data){
          console.log("key---文件---",data)
          if(key==="客厅照片"){ this.ktImgList=data }
          else if(key==="卧室照片"){ this.wsImgList=data }
          else if(key==="厨房照片"){ this.cfImgList=data }
          else if(key==="卫生间照片"){ this.wsjImgList=data }
          else if(key==="其他照片"){ this.qtImgList=data }

          else if(key==="房屋托管合同信息"){ this.fwtghtImgList=data }
          else if(key==="产证信息"){ this.czImgList=data }
          else if(key==="身份证信息"){ this.sfzImgList=data }
          else if(key==="授权委托书"){ this.sqhtsImgList=data } 
          else if(key==="租客上传"){ this.zkscImgList=data } 
          else if(key==="上门维修"){ this.smwxImgList=data } 
          else {this.fileList=data}

        },
        getImage(key){
          if(key==="客厅照片"){return this.ktImgList ;}
          else if(key==="卧室照片"){ return this.wsImgList ; }
          else if(key==="厨房照片"){ return this.cfImgList ; }
          else if(key==="卫生间照片"){ return this.wsjImgList ; }
          else if(key==="其他照片"){ return this.qtImgList ; }

          else if(key==="房屋托管合同信息"){ return this.fwtghtImgList ;  }
          else if(key==="产证信息"){  return this.czImgList ; }
          else if(key==="身份证信息"){ return this.sfzImgList ;  }
          else if(key==="授权委托书"){ return this.sqhtsImgList ;  } 
          else { return this.fileList ; }
         
        },

        getHeight(value) {
          if (value == null) {
            return 50;
          }

        const processedValue = value.toString().replace(/\s+/g, ',');

          const length = processedValue.length; 
          const lines = Math.ceil(length / 28);
          return lines * 50;
        },
        getMaxLineHeight(index) {
          // console.log("key--",this.keyList[index])
          // console.log("value-",this.dataDetail[this.keyList[index]])
  
          const height1 = this.getHeight(this.dataDetail[this.keyList[index]]);
          // console.log("height1--",height1)
          const height2 = this.getHeight(this.dataDetail[this.keyList[index + 1]]);
          // console.log("height2--",height2)
          const maxHeight = Math.max(height1, height2);
          return { height: maxHeight + 'px', lineHeight: maxHeight + 'px' };
        },
        getMaxLineHeight2(index) {
          const height1 = this.getHeight(this.dataDetail[this.otherKeyList[index]]);
          const height2 = this.getHeight(this.dataDetail[this.otherKeyList[index + 1]]);
          const maxHeight = Math.max(height1, height2);
          return { height: maxHeight + 'px', lineHeight: maxHeight + 'px' };
        },
      cancel(){
        this.detailModal=false
      }
    }


}
</script>

  
  <style lang="scss" >
@import 'base_detail_modal.scss'; 

.base-modal{
        width: 100%;
        height: 700px;
        padding: 20px;
        .base-modal-line{
            width: 100%;
            height: auto;
            display: flex;
            gap:2%;
            align-items: center;
            justify-content: center;
            
            .item_1{
                width: 48%;
                height: auto;
                display: flex; 
                font-size: 24px;  
                text-align: center;
                 line-height: 50px;
                 border-bottom: 1px solid #c3c3c3;
                 border-right: 1px solid #c3c3c3;
                 border-left: 1px solid #c3c3c3;
                .item_1-title{
                    width: 35%; 
                    height: auto;
                    color:#333333;
                    background-color: #cccccc;
                    
                }
                .item_1-value{
                    width: 65%;
                    color:#555555;
                    word-wrap: break-word; /* 允许长单词换行 */
                    word-break: break-all; /* 允许在任意字符处换行 */
                    overflow-wrap: break-word; /* 处理长单词换行 */
                }
               
                
            }
            .item_2{
                width: 100%;
                height: auto;
                .item_2-title{
                    width: 100%;
                    color:#333333;
                }
            }

        }
    }
  </style>